<template>
    <div class='summary-container' v-show='product.product'>
        <div v-show='product.product' class='product-title'>{{product.product}}</div>
        <div class='price-container'>
            <div v-if='product.mix_six_price > 0 && product.subscription_product_type == "lock_it_in"' class='price-slashed'>£{{parseFloat(product.mix_six_price).toFixed(2)}} <span>Mix Six</span></div>
            <div class='price'>£{{parseFloat(product.price).toFixed(2)}} {{ product.subscription_product_type == 'lock_it_in' ? 'LOCK IT IN price' : '' }} per {{product.uda}}</div>
        </div>

       
    </div>
</template>

<script>
export default {
    props: ['product']
}
</script>

<style lang="scss" scoped>
.summary-container{
    display: flex;
    flex-direction: column;
    gap: 15px;
    flex-grow: 1;
}

.product-title{
    font-size: 1.4rem;
    font-weight: 600;
    line-height: 40px;
    color: var(--black);
}

.price-container{
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: start;
}

.price{
    font-size: 1.39rem;
    font-weight: 600;
    color: var(--black);
}

.price-slashed{
    font-size: 1.21rem;
    font-weight: 500;
    color: var(--black);
}
.price-slashed span{
    //border-bottom: 1px dashed #283533;
}

.ratings-container{
    cursor: pointer;
}

.details{
    // max-width: 500px;
}

.favourite{
    font-size: 1.2rem;
    color: #fa5252;
}

.product-code{
    color: #737373;

}
.summary-separator{
    border: 1px solid #B9B3AE;
    margin-top: 10px;
    margin-bottom: 10px;
}
</style>